import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    defaultVCycleElementResource,
    useVCycleElementActions,
    VCycleElementMutationResourceSchema,
} from '../../../../resource/resources/artifacts/use_case/representation/vcycleElementResource';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../util/useSelectorFunctions';
import { VCycleElementContent } from './VCycleElementContent';

export const VCycleElementEditDialog = ({
    onClose,
    objectId,
    versionedInId,
    projectId,
}: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
    projectId: string | undefined | null;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const vcycleElementActions = useVCycleElementActions();
    const vcycleElementQuery = vcycleElementActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionedInId);
    const updateVcycleElement = vcycleElementActions.useUpdateResource();
    const validation = vcycleElementActions.useValidateResource(vcycleElementQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: VCycleElementMutationResourceSchema,
        defaultValues: defaultVCycleElementResource,
        submitHandler: async (data) => {
            await updateVcycleElement.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: vcycleElementQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit V-Cycle Element'}
            resourceType={ResourceType.V_CYCLE_ELEMENT}
            resourceValidationResult={validation.data}
            metaDataInfo={vcycleElementQuery.data}
        >
            <QueryBaseComponent name="VcycleElement" query={vcycleElementQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <VCycleElementContent
                        projectId={projectId}
                        projectVersionId={versionedInId}
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={vcycleElementQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
